import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook } from 'lucide-react';
import { CLINIC_INFO } from '../data';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white pt-20 pb-10">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
          {/* Brand Column */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center">
              <img 
                src="https://assets.auxodev.dk/assets/767bb60f-8ec8-4a4c-940e-ed49b89257a3/597fff01-44e7-478d-9a63-9d32022c74eb.png" 
                alt="CDH Massage Logo" 
                className="h-36 w-auto" 
              />
            </Link>
            <p className="text-zinc-400 text-xs sm:text-sm leading-relaxed max-w-xs">
              Professionel behandling med fokus på din krops velvære og balance. Over 10 års erfaring – nu med klinik i Rødekro.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/CDHSport/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-zinc-800 p-2 rounded-full hover:bg-emerald-500 transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Menu</h3>
            <ul className="space-y-4">
              <li><Link to="/behandlinger" className="text-zinc-400 hover:text-emerald-400 transition-colors text-sm">Behandlinger</Link></li>
              <li><Link to="/priser" className="text-zinc-400 hover:text-emerald-400 transition-colors text-sm">Priser & Åbningstider</Link></li>
              <li><Link to="/om-mig" className="text-zinc-400 hover:text-emerald-400 transition-colors text-sm">Om Carsten</Link></li>
              <li><Link to="/kontakt" className="text-zinc-400 hover:text-emerald-400 transition-colors text-sm">Kontakt os</Link></li>
            </ul>
          </div>

          {/* Opening Hours */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Åbningstider</h3>
            <ul className="space-y-3">
              {CLINIC_INFO.openingHours.map((item, idx) => (
                <li key={idx} className="flex justify-between text-sm">
                  <span className="text-zinc-400">{item.day}</span>
                  <span className="text-white font-medium">{item.hours}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">Kontakt</h3>
            <ul className="space-y-5">
              <li className="flex items-start">
                <MapPin className="w-5 h-5 mr-3 text-emerald-400 shrink-0 mt-0.5" />
                <div>
                  <a 
                    href="https://maps.app.goo.gl/zduoinBMcwsKXgZPA"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-zinc-400 leading-snug hover:text-emerald-400 transition-colors block"
                  >
                    {CLINIC_INFO.address}
                  </a>
                  <span className="block text-xs text-zinc-500 mt-1 leading-relaxed">
                    Direkte på banegården. Indgang ved enden af bygningen ved cykelskuret.
                  </span>
                </div>
              </li>
              <li className="flex items-center">
                <Phone className="w-5 h-5 mr-3 text-emerald-400 shrink-0" />
                <a href={`tel:${CLINIC_INFO.phone}`} className="text-sm text-zinc-400 hover:text-emerald-400 transition-colors">
                  {CLINIC_INFO.phone}
                </a>
              </li>
              <li className="flex items-center">
                <Mail className="w-5 h-5 mr-3 text-emerald-400 shrink-0" />
                <a href={`mailto:${CLINIC_INFO.email}`} className="text-sm text-zinc-400 hover:text-emerald-400 transition-colors">
                  {CLINIC_INFO.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-zinc-800 flex flex-col md:flex-row justify-between items-center text-xs text-zinc-500 space-y-4 md:space-y-0">
          <p>© {currentYear} {CLINIC_INFO.name}. Alle rettigheder forbeholdes.</p>
          <div className="flex space-x-6">
            <Link to="/praktisk-info" className="hover:text-white transition-colors">Privatlivspolitik</Link>
            <Link to="/praktisk-info" className="hover:text-white transition-colors">Betingelser</Link>
            <span>Designet af Auxo</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
